// extracted by mini-css-extract-plugin
export default {"Body":"MarksOnLine_Body__nTuS7","Mark":"MarksOnLine_Mark__i+jfY"};